"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonLint = void 0;
const jsonLint_types_1 = require("./types/jsonLint.types");
const codemirror_1 = require("codemirror");
const state_1 = require("@codemirror/state");
const json_to_yaml_1 = require("@catalystic/json-to-yaml");
const lang_json_1 = require("@codemirror/lang-json");
const yaml_1 = require("yaml");
const json_2_csv_1 = require("json-2-csv");
class jsonLint {
    constructor(options) {
        this.tabSize = 4;
        this.options = options;
        this.setPresentation();
    }
    setPresentation() {
        const tab = new state_1.Compartment();
        const editorState = state_1.EditorState.create({
            extensions: [
                codemirror_1.basicSetup,
                tab.of(state_1.EditorState.tabSize.of(this.tabSize)),
                codemirror_1.EditorView.lineWrapping,
                codemirror_1.EditorView.theme({}, { dark: true }),
                (0, lang_json_1.json)(),
            ],
        });
        this.editor = new codemirror_1.EditorView({
            state: editorState,
            parent: document.getElementById(this.options.editorId),
        });
        this.previewer = new codemirror_1.EditorView({
            state: editorState,
            parent: document.getElementById(this.options.previewerId),
        });
    }
    formatJSON(jobType) {
        const jsonString = this.editor.contentDOM.innerText;
        const lintErrors = this.getLintErrors(jsonString);
        let previewerContent;
        if (lintErrors.length > 0) {
            previewerContent = lintErrors.join('\n');
        }
        else {
            switch (jobType) {
                case jsonLint_types_1.JobType.MINIFY:
                    previewerContent = this.minifyJSON(jsonString);
                    break;
                case jsonLint_types_1.JobType.JSON_TO_YAML:
                    previewerContent = this.jsonToYaml(jsonString);
                    break;
                case jsonLint_types_1.JobType.JSON_TO_CSV:
                    previewerContent = this.jsonToCsv(jsonString);
                    break;
                default:
                    previewerContent = this.prettifyJSON(jsonString, this.tabSize);
            }
        }
        this.previewer.contentDOM.innerText = previewerContent;
    }
    getLintErrors(jsonString) {
        const lintErrors = [];
        try {
            // Attempt to parse the JSON to find syntax errors
            JSON.parse(jsonString);
        }
        catch (err) {
            lintErrors.push("Syntax Error: " + err.message);
            return lintErrors;
        }
        return lintErrors;
    }
    setTabSize(tabSize) {
        this.tabSize = tabSize;
    }
    prettifyJSON(jsonString, tabSize) {
        return JSON.stringify(JSON.parse(jsonString), null, tabSize);
    }
    minifyJSON(jsonString) {
        return JSON.stringify(JSON.parse(jsonString));
    }
    jsonToYaml(jsonString) {
        const jsonObject = JSON.parse(jsonString);
        return (0, json_to_yaml_1.convert)(jsonObject);
    }
    jsonToCsv(jsonString) {
        const jsonObject = JSON.parse(jsonString);
        return (0, json_2_csv_1.json2csv)(jsonObject);
    }
    convertYamlToJson(jobType) {
        const yamlString = this.editor.contentDOM.innerText;
        const lintErrors = this.validateYaml(yamlString);
        let previewerContent;
        if (lintErrors.length > 0) {
            previewerContent = lintErrors.join('\n');
        }
        else {
            const jsonString = this.yamlToJson(yamlString);
            switch (jobType) {
                case jsonLint_types_1.JobType.MINIFY:
                    previewerContent = this.minifyJSON(jsonString);
                    break;
                default:
                    previewerContent = this.prettifyJSON(jsonString, this.tabSize);
            }
        }
        this.previewer.contentDOM.innerText = previewerContent;
    }
    validateYaml(yamlString) {
        const lintErrors = [];
        try {
            (0, yaml_1.parse)(yamlString);
        }
        catch (err) {
            lintErrors.push("Syntax Error: " + err.message);
            return lintErrors;
        }
        return lintErrors;
    }
    yamlToJson(yamlString) {
        try {
            const jsonObject = (0, yaml_1.parse)(yamlString);
            return JSON.stringify(jsonObject);
        }
        catch (error) {
            return "Invalid YAML string. Error: " + error.message;
        }
    }
}
exports.jsonLint = jsonLint;
